import { useState } from 'react'

import { deleteCookiesAuth } from '@wiggot/auth/utils/cookies'
import { postLogOut, postLogOutV2 } from '../services/auth.services'
import { ROUTES } from '../constants/routes'

export const useAuth = () => {
  const [isLoadingLogout, setIsLoadingLogout] = useState(false)

  const handleLogout = async (redirectTo?: string) => {
    const redirectToUrl = redirectTo || ROUTES.AUTH_LOGIN
    try {
      setIsLoadingLogout(true)
      await postLogOut()
      await postLogOutV2()
    } finally {
      deleteCookiesAuth()
      window.location.href = redirectToUrl
      setIsLoadingLogout(false)
    }
  }
  return {
    isLoadingLogout,
    handleLogout
  }
}
